export default __webpack_public_path__ + "static/media/BR - Forensics One.e6d6ab7b.png";